module.exports = __webpack_public_path__ + "static/img/14.deb884e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/14.png
// module id = sBMR
// module chunks = 10